var e = 10,
    r = 20,
    t = 30,
    s = 40,
    i = 50,
    n = 60,
    o = {
  trace: 10,
  debug: 20,
  info: 30,
  warn: 40,
  error: 50,
  fatal: 60
},
    l = {};

function a(e) {
  return "string" == typeof e ? o[e.toLowerCase()] : e;
}

function c(e, r) {
  return c = Object.setPrototypeOf || function (e, r) {
    return e.__proto__ = r, e;
  }, c(e, r);
}

function u() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function f(e, r, t) {
  return f = u() ? Reflect.construct : function (e, r, t) {
    var s = [null];
    s.push.apply(s, r);
    var i = new (Function.bind.apply(e, s))();
    return t && c(i, t.prototype), i;
  }, f.apply(null, arguments);
}

function h(e) {
  if (null == e) return e;
  if (Array.isArray(e)) return e.slice();

  if ("object" == typeof e) {
    var r = {};
    return Object.keys(e).forEach(function (t) {
      r[t] = e[t];
    }), r;
  }

  return e;
}

function v(e) {
  return void 0 === e ? "undefined" : null === e ? "null" : Array.isArray(e) ? "[ " + e.map(function (e) {
    return v(e);
  }).join(", ") + " ]" : "object" == typeof e ? JSON.stringify(e) : "function" == typeof e ? "[Function: " + e.name + "]" : "boolean" == typeof e || "number" == typeof e ? e : "'" + e.toString() + "'";
}

function p(e) {
  if ("string" != typeof e) {
    for (var r = new Array(arguments.length), t = 0; t < arguments.length; t++) {
      r[t] = v(arguments[t]);
    }

    return r.join(" ");
  }

  for (var s = /%[sdj%]/g, i = 1, n = arguments, o = n.length, l = String(e).replace(s, function (e) {
    if ("%%" === e) return "%";
    if (i >= o) return e;

    switch (e) {
      case "%s":
        return String(n[i++]);

      case "%d":
        return Number(n[i++]);

      case "%j":
        try {
          return JSON.stringify(n[i++]);
        } catch (e) {
          return "[Circular]";
        }

      default:
        return e;
    }
  }), a = n[i]; i < o; a = n[++i]) {
    l += null === a || "object" != typeof a ? " " + a : " " + v(a);
  }

  return l;
}

function m(e, r) {
  var t = e.split("\n");
  t[0] && t[0].indexOf("call-stack-error") >= 0 && t.shift();
  var s = t[r],
      i = null;

  if (s) {
    var n = /^\s*(at|.*@)\s*(.+)?$/.exec(s);
    i = Array.isArray(n) && n[2] ? n[2] : s;
  }

  return i;
}

Object.keys(o).forEach(function (e) {
  l[o[e]] = e;
});
var y = {};

function d(e, r) {
  if (r) {
    if (y[r]) return;
    y[r] = !0;
  }

  console.error(e + "\n");
}

function g(e) {
  return y[e];
}

function w() {
  var e = [];
  return function (r, t) {
    return t && "object" == typeof t ? -1 !== e.indexOf(t) ? "[Circular]" : (e.push(t), t) : t;
  };
}

var b = /*#__PURE__*/function () {
  function e() {}

  return e.prototype.write = function (e) {
    e.level < 30 ? console.log(e) : e.level < 40 ? console.info(e) : e.level < 50 ? console.warn(e) : console.error(e), e.err && e.err.stack && console.error(e.err.stack), e.obj && console.log(e.obj);
  }, e;
}(),
    j = /*#__PURE__*/function () {
  function e(r, t, s) {
    var i,
        n,
        o,
        l,
        a = this;
    if (!(this instanceof e)) return new e(r, t);
    if (void 0 !== t && (i = r, r = t, !(i instanceof e))) throw new TypeError("invalid Logger creation: do not pass a second arg");
    if (!r) throw new TypeError("options (object) is required");

    if (i) {
      if (r.name) throw new TypeError("invalid options.name: child cannot set logger name");
    } else if (!r.name) throw new TypeError("options.name (string) is required");

    if (r.stream && r.streams) throw new TypeError('cannot mix "streams" and "stream" options');
    if (r.streams && !Array.isArray(r.streams)) throw new TypeError("invalid options.streams: must be an array");
    if (r.serializers && ("object" != typeof r.serializers || Array.isArray(r.serializers))) throw new TypeError("invalid options.serializers: must be an object");

    if (i && s) {
      this._level = i._level, this.streams = i.streams, this.serializers = i.serializers, this.src = i.src, n = this.fields = {};
      var c = Object.keys(i.fields);

      for (l = 0; l < c.length; l++) {
        n[o = c[l]] = i.fields[o];
      }

      var u = Object.keys(r);

      for (l = 0; l < u.length; l++) {
        n[o = u[l]] = r[o];
      }
    } else {
      if (i) {
        for (this._level = i._level, this.streams = [], l = 0; l < i.streams.length; l++) {
          var f = h(i.streams[l]);
          this.streams.push(f);
        }

        this.serializers = h(i.serializers), this.src = i.src, this.fields = h(i.fields), r.level && this.level(r.level);
      } else this._level = Number.POSITIVE_INFINITY, this.streams = [], this.serializers = null, this.src = !1, this.fields = {};

      r.stream ? this.addStream({
        type: "stream",
        stream: r.stream,
        level: r.level
      }) : r.streams ? r.streams.forEach(function (e) {
        a.addStream(e, r.level);
      }) : i && r.level ? this.level(r.level) : i || this.addStream({
        type: "raw",
        stream: new b(),
        level: r.level
      }), r.serializers && this.addSerializers(r.serializers), r.src && (this.src = !0), delete (n = h(r)).stream, delete n.level, delete n.streams, delete n.serializers, delete n.src, this.serializers && this._applySerializers(n), Object.keys(n).forEach(function (e) {
        a.fields[e] = n[e];
      });
    }
  }

  var r = e.prototype;
  return r.addStream = function (e, r) {
    void 0 === r && (r = 30), (e = h(e)).type = "raw", e.level = a(e.level || r), e.level < this._level && (this._level = e.level), this.streams.push(e), delete this.haveNonRawStreams;
  }, r.addSerializers = function (e) {
    var r = this;
    this.serializers || (this.serializers = {}), Object.keys(e).forEach(function (t) {
      var s = e[t];
      if ("function" != typeof s) throw new TypeError(p('invalid serializer for "%s" field: must be a function', t));
      r.serializers[t] = s;
    });
  }, r.child = function (e, r) {
    return new this.constructor(this, e || {}, r);
  }, r.level = function (e) {
    if (void 0 === e) return this._level;

    for (var r = a(e), t = this.streams.length, s = 0; s < t; s++) {
      this.streams[s].level = r;
    }

    this._level = r;
  }, r.levels = function (e, r) {
    if (void 0 === e) return this.streams.map(function (e) {
      return e.level;
    });
    var t;

    if ("number" == typeof e) {
      if (void 0 === (t = this.streams[e])) throw new Error("invalid stream index: " + e);
    } else {
      for (var s = this.streams.length, i = 0; i < s; i++) {
        var n = this.streams[i];

        if (n.name === e) {
          t = n;
          break;
        }
      }

      if (!t) throw new Error(p('no stream with name "%s"', e));
    }

    if (void 0 === r) return t.level;
    var o = a(r);
    t.level = o, o < this._level && (this._level = o);
  }, r._applySerializers = function (e, r) {
    var t = this;
    Object.keys(this.serializers).forEach(function (s) {
      if (!(void 0 === e[s] || r && r[s])) try {
        e[s] = t.serializers[s](e[s]);
      } catch (r) {
        d(p('bunyan: ERROR: Exception thrown from the "%s" Bunyan serializer. This should never happen. This is a bugin that serializer function.\n%s', s, r.stack || r)), e[s] = p('(Error in Bunyan log "%s" serializer broke field. See stderr for details.)', s);
      }
    });
  }, r._emit = function (e, r) {
    var t, s;
    if (void 0 === this.haveNonRawStreams) for (this.haveNonRawStreams = !1, t = 0; t < this.streams.length; t++) {
      if (!this.streams[t].raw) {
        this.haveNonRawStreams = !0;
        break;
      }
    }
    if (r || this.haveNonRawStreams) try {
      s = JSON.stringify(e, w()) + "\n";
    } catch (r) {
      var i = r.stack.split(/\n/g, 2).join("\n");
      d('bunyan: ERROR: Exception in `JSON.stringify(rec)`. You can install the "safe-json-stringify" module to have Bunyan fallback to safer stringification. Record:\n' + function (e, r) {
        return r || (r = "    "), r + e.split(/\r?\n/g).join("\n" + r);
      }(p("%s\n%s", e, r.stack)), i), s = p("(Exception in JSON.stringify(rec): %j. See stderr for details.)\n", r.message);
    }
    if (r) return s;
    var n = e.level;

    for (t = 0; t < this.streams.length; t++) {
      var o = this.streams[t];
      o.level <= n && o.stream.write(e);
    }

    return s;
  }, e;
}();

function z(e) {
  return function () {
    var r = this;

    function t(t) {
      var n;
      t[0] instanceof Error ? (s = {
        err: r.serializers && r.serializers.err ? r.serializers.err(t[0]) : k.err(t[0])
      }, n = {
        err: !0
      }, i = 1 === t.length ? [s.err.message] : Array.prototype.slice.call(t, 1)) : "object" != typeof t[0] && null !== t[0] || Array.isArray(t[0]) ? (s = null, i = Array.prototype.slice.call(t)) : (s = t[0], i = 1 === t.length && s.err && s.err instanceof Error ? [s.err.message] : Array.prototype.slice.call(t, 1));
      var o = h(r.fields);
      o.level = e;
      var a = s ? h(s) : null;
      if (a && (r.serializers && r._applySerializers(a, n), Object.keys(a).forEach(function (e) {
        o[e] = a[e];
      })), o.levelName = l[e], o.msg = i.length ? p.apply(r, i) : "", o.time || (o.time = new Date()), r.src && !o.src) try {
        throw new Error("call-stack-error");
      } catch (e) {
        var c = e.stack ? m(e.stack, 2) : "";
        c || g("src") || d("Unable to determine src line info", "src"), o.src = c || "";
      }
      return o.v = 1, o;
    }

    var s = null,
        i = arguments,
        n = null;
    if (0 === arguments.length) return this._level <= e;
    this._level > e || (n = t(i), this._emit(n));
  };
}

function S(e) {
  var r = e.stack || e.toString();

  if (e.cause && "function" == typeof e.cause) {
    var t = e.cause();
    t && (r += "\nCaused by: " + S(t));
  }

  return r;
}

j.prototype.trace = z(10), j.prototype.debug = z(20), j.prototype.info = z(30), j.prototype.warn = z(40), j.prototype.error = z(50), j.prototype.fatal = z(60);
var k = {
  err: function err(e) {
    return e && e.stack ? {
      message: e.message,
      name: e.name,
      stack: S(e),
      code: e.code,
      signal: e.signal
    } : e;
  }
};

function E() {
  return f(j, [].slice.call(arguments));
}

var A = {
  levels: {
    trace: "color: DeepPink",
    debug: "color: GoldenRod",
    info: "color: DarkTurquoise",
    warn: "color: Purple",
    error: "color: Crimson",
    fatal: "color: Black"
  },
  def: "color: DimGray",
  msg: "color: SteelBlue",
  src: "color: DimGray; font-style: italic; font-size: 0.9em"
},
    R = /*#__PURE__*/function () {
  function e(e) {
    var r = void 0 === e ? {} : e,
        t = r.logByLevel,
        s = r.css,
        i = void 0 === s ? A : s;
    this.logByLevel = void 0 !== t && t, this.css = i;
  }

  return e.prototype.write = function (e) {
    var r,
        t,
        s = this.css.def,
        i = this.css.msg,
        n = this.css.src,
        o = e.childName ? e.name + "/" + e.childName : e.name,
        a = l[e.level],
        c = (Array(6 - a.length).join(" ") + a).toUpperCase();
    this.logByLevel ? (10 === e.level ? a = "debug" : 60 === e.level && (a = "error"), t = "function" == typeof console[a] ? console[a] : console.log) : t = console.log, r = e.level < 20 ? this.css.levels.trace : e.level < 30 ? this.css.levels.debug : e.level < 40 ? this.css.levels.info : e.level < 50 ? this.css.levels.warn : e.level < 60 ? this.css.levels.error : this.css.levels.fatal;

    var u = function u(e, r) {
      return Array(r + 1 - (e + "").length).join("0") + e;
    },
        f = [];

    f.push("[%s:%s:%s:%s] %c%s%c: %s: %c%s " + (e.src ? "%c%s" : "")), f.push(u(e.time.getHours(), 2)), f.push(u(e.time.getMinutes(), 2)), f.push(u(e.time.getSeconds(), 2)), f.push(u(e.time.getMilliseconds(), 4)), f.push(r), f.push(c), f.push(s), f.push(o), f.push(i), f.push(e.msg), e.src && (f.push(n), f.push(e.src)), e.obj && (f.push("\n"), f.push(e.obj)), e.err && e.err.stack && (f.push("\n"), f.push(e.err.stack)), t.apply(console, f);
  }, e.getDefaultCss = function () {
    return A;
  }, e;
}(),
    O = /*#__PURE__*/function () {
  function e(e) {
    var r = (void 0 === e ? {} : e).logByLevel;
    this.logByLevel = void 0 !== r && r;
  }

  return e.prototype.write = function (e) {
    var r,
        t = e.childName ? e.name + "/" + e.childName : e.name,
        s = l[e.level],
        i = (Array(6 - s.length).join(" ") + s).toUpperCase();
    this.logByLevel ? (10 === e.level ? s = "debug" : 60 === e.level && (s = "error"), r = "function" == typeof console[s] ? console[s] : console.log) : r = console.log;

    var n = function n(e, r) {
      return Array(r + 1 - (e + "").length).join("0") + e;
    },
        o = "[" + n(e.time.getHours(), 2) + ":";

    o += n(e.time.getMinutes(), 2) + ":", o += n(e.time.getSeconds(), 2) + ":", o += n(e.time.getMilliseconds(), 4) + "] ", o += i + ": ", o += t + ": ", o += e.msg, e.src && (o += " (" + e.src + ")"), r.call(console, o), e.err && e.err.stack && r.call(console, e.err.stack), e.obj && r.call(console, e.obj);
  }, e;
}();

export { R as ConsoleFormattedStream, O as ConsolePlainStream, b as ConsoleRawStream, r as DEBUG, i as ERROR, n as FATAL, t as INFO, j as Logger, e as TRACE, s as WARN, E as createLogger, o as levelFromName, l as nameFromLevel, a as resolveLevel, w as safeCycles, k as stdSerializers };